import React, { useState } from "react";
import { TrendingUp } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-emerald_deep/10 rounded-xl px-4 py-3 shadow-lg text-sm">
      <p className="text-text_muted text-xs mb-1">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} style={{ color: p.color }} className="font-semibold">
          {p.name}: {p.dataKey === "revenue" ? `₹${(p.value / 100).toLocaleString()}` : p.value}
        </p>
      ))}
    </div>
  );
};

export default function AnalyticsChart({ analytics }) {
  const [chartType, setChartType] = useState("enrollments");
  const data = chartType === "enrollments" ? analytics.enrollments_by_date : analytics.contacts_by_date;
  const formatted = data.map(d => ({
    ...d,
    date: new Date(d.date).toLocaleDateString("en-IN", { day: "numeric", month: "short" })
  }));

  return (
    <div data-testid="analytics-chart" className="bg-white rounded-2xl border border-emerald_deep/5 shadow-sm p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <TrendingUp size={20} className="text-accent" />
          <h3 className="font-serif text-xl text-emerald_deep">Last 30 Days</h3>
        </div>
        <div className="flex gap-2">
          {[{ id: "enrollments", label: "Orders" }, { id: "contacts", label: "Contacts" }].map(t => (
            <button key={t.id} onClick={() => setChartType(t.id)} data-testid={`chart-toggle-${t.id}`}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all ${
                chartType === t.id ? "bg-emerald_deep text-bone" : "bg-bone text-text_muted hover:text-emerald_deep"
              }`}>{t.label}</button>
          ))}
        </div>
      </div>
      {formatted.length === 0 ? (
        <div className="text-center py-12 text-text_muted text-sm">No data for this period</div>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={formatted} barSize={20}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e5e5" vertical={false} />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#888" }} axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#888" }} axisLine={false} tickLine={false} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="count" name="Count" fill="#132A13" radius={[6, 6, 0, 0]} />
            {chartType === "enrollments" && (
              <Bar dataKey="revenue" name="Revenue" fill="#D98A6C" radius={[6, 6, 0, 0]} />
            )}
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
